import { render } from "./ValidateToken.vue?vue&type=template&id=9a6a1380"
import script from "./ValidateToken.vue?vue&type=script&lang=js"
export * from "./ValidateToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__